import owd from 'owd/owd';

export default class ScrollTop extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
		this.on('click', (e) => {
			e.preventDefault();

			$('html,body').animate({
				scrollTop: 0
			}, 800, 'easeOutQuint');
		});

		// this.on('click', () => {});
		// this.on('click', this.app.$window, () => {});
		// this.on('click', '.dupa', () => {});

		// $('body').on('click', '.element', functiuon() {

		// })
	}
}

owd.registerComponent('scroll-top', {
	component: ScrollTop
});